const API = process.env.REACT_APP_API_URL || '';

function getToken(): string | null {
  return localStorage.getItem('token');
}

function authHeaders(): Record<string, string> {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function register(email: string, username: string, password: string) {
  const resp = await fetch(`${API}/api/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, username, password }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.detail || 'Registration failed');
  localStorage.setItem('token', data.access_token);
  return data;
}

export async function login(email: string, password: string) {
  const resp = await fetch(`${API}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.detail || 'Login failed');
  localStorage.setItem('token', data.access_token);
  return data;
}

export async function getMe() {
  const resp = await fetch(`${API}/api/auth/me`, { headers: authHeaders() });
  if (!resp.ok) throw new Error('Not authenticated');
  return resp.json();
}

export async function findSubreddits(tags: string[], promoOnly = true) {
  const resp = await fetch(`${API}/api/subreddits/find`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ tags, promo_only: promoOnly, min_members: 0 }),
  });
  return resp.json();
}

export async function getCategories() {
  const resp = await fetch(`${API}/api/subreddits/categories`);
  return resp.json();
}

export async function connectBluesky(handle: string, appPassword: string) {
  const resp = await fetch(`${API}/api/accounts/bluesky`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ handle, app_password: appPassword }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.detail || 'Connection failed');
  return data;
}

export async function connectTwitter(apiKey: string, apiSecret: string, accessToken: string, accessSecret: string) {
  const resp = await fetch(`${API}/api/accounts/twitter`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ api_key: apiKey, api_secret: apiSecret, access_token: accessToken, access_token_secret: accessSecret }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.detail || 'Connection failed');
  return data;
}

export async function getAccounts() {
  const resp = await fetch(`${API}/api/accounts`, { headers: authHeaders() });
  return resp.json();
}

export async function createPost(title: string, body: string | null, imageUrl: string | null, platforms: string[], subreddits: string[] | null) {
  const resp = await fetch(`${API}/api/posts`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ title, body, image_url: imageUrl, platforms, subreddits }),
  });
  const data = await resp.json();
  if (!resp.ok) throw new Error(data.detail || 'Post failed');
  return data;
}

export async function getPosts() {
  const resp = await fetch(`${API}/api/posts`, { headers: authHeaders() });
  return resp.json();
}

export async function getAnalytics() {
  const resp = await fetch(`${API}/api/analytics`, { headers: authHeaders() });
  return resp.json();
}

export function logout() {
  localStorage.removeItem('token');
  window.location.href = '/login';
}

export function isLoggedIn(): boolean {
  return !!getToken();
}
